import { render, staticRenderFns } from "./reg_short_text_question.vue?vue&type=template&id=a5ef9af8&"
import script from "./reg_short_text_question.vue?vue&type=script&lang=js&"
export * from "./reg_short_text_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports